export enum FileUploadTypes {
  Encounters = 'encounters',
  Combined = 'combined',
  Labs = 'labs',
}

export enum FileUploadModes {
  Combined = 'Combined',
  Separate = 'Separate',
}

export const NotIncludedInFile = '<Not included in file>';
